import styled from '@emotion/styled/macro';
import { css } from '@emotion/react';

import { Label } from '@components/Form/style';
import theme from '@styles/theme';

export const StyledText = styled.span``;

export const Checkmark = styled.span`
  position: absolute;
  height: 25px;
  width: 25px;
  top: 50%;
  left: 0;
  transform: translateY(-50%);

  background-color: ${theme.colors.white};
  border-radius: 4px;
  border: 2px solid #8d8d8d;
  &:after {
    content: '';
    position: absolute;
    display: none;
  }
`;

export const StyledInput = styled(Label)`
  position: relative;
  padding-left: 35px;
  padding-top: 1px;

  margin-right: ${({ ofGroup }) => (ofGroup ? '35' : '15')}px;
  margin-top: ${({ ofGroup }) => (ofGroup ? '16px' : '0')};
  cursor: pointer;
  user-select: none;

  & input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
  }

  &:hover input ~ ${Checkmark} {
    border-color: ${theme.colors.emph};
  }

  & input:checked ~ ${StyledText} {
    color: ${theme.colors.emph};
  }

  & input:checked ~ ${Checkmark} {
    border-color: ${theme.colors.emph};
    background-color: ${theme.colors.emph};
  }

  & input:checked ~ ${Checkmark}:after {
    display: block;
  }

  & ${Checkmark}:after {
    left: 7px;
    top: 2px;
    width: 7px;
    height: 14px;
    border: solid ${theme.colors.white};
    border-width: 0 3px 3px 0;
    transform: rotate(45deg);
  }

  ${({ isDisabled }) =>
    isDisabled &&
    css`
      pointer-events: none;
      cursor: not-allowed;
      filter: grayscale(0.5);

      ${Checkmark} {
        background-color: #eee;
      }
    `}
`;

export const InputWrapper = styled.div`
  position: relative;
  display: flex;
  border-color: transparent;
  border-style: solid;
  border-width: 1px;
  border-radius: 4px;

  ${StyledText} {
    color: ${({ withError }) => (withError ? theme.colors.error : 'inherit')}
`;
